import { handleAPI, API_VERSION_ONE } from '../../../../../itrust_common/utils/apiUtils';

export function visionInsuranceServicesLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_on`;

  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_SERVICES_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function visionInsuranceServiceUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/add_on/${data.id}`;
  const method = 'PUT'
  return {
    type: 'VISION_INSURANCE_SERVICE_UPDATE',
    meta: { id: data.id },
    payload: handleAPI(url, filters, method, { add_on: data })
  }
}

export function visionInsuranceEligibilityVerify(data, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs`;
  const method = 'POST'
  return {
    type: 'VISION_INSURANCE_ELIGIBILITY_VERIFY',
    payload: handleAPI(url, filters, method, data)
  }
}

export function visionInsuranceEligibilityLogLoad(id) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}`;
  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_ELIGIBILITY_LOG_LOAD',
    payload: handleAPI(url, {}, method)
  }
}

export function visionInsuranceEligibilityRequirementsLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/eligibility_requirements`;
  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_ELIGIBILITY_REQUIREMENTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function visionInsuranceServiceLoad(id) {
  const url = `/${API_VERSION_ONE}/add_on/${id}`;
  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_SERVICE_LOAD',
    payload: handleAPI(url, {}, method)
  }
}

export function visionInsuranceCredentialProcessing(id) {
  return {
    type: 'VISION_INSURANCE_CREDENTIAL_PROCESSING',
    data: { id }
  }
}

export function visionInsuranceCredentialRetryFailed(service) {
  return {
    type: 'VISION_INSURANCE_CREDENTIAL_RETRY_FAILED',
    data: { service }
  }
}

export function visionInsuranceDetailView(data) {
  return {
    type: 'VISION_INSURANCE_DETAIL_VIEW',
    data
  };
}

export function visionInsuranceEdit(data) {
  return {
    type: 'VISION_INSURANCE_EDIT',
    data
  };
}

export function visionInsuranceEditReset() {
  return {
    type: 'VISION_INSURANCE_EDIT_RESET',
  };
}

export function visionInsuranceEligibilityEdit(data) {
  return {
    type: 'VISION_INSURANCE_ELIGIBILITY_EDIT',
    data
  };
}

export function visionInsuranceEligibilityReset() {
  return {
    type: 'VISION_INSURANCE_ELIGIBILITY_RESET',
  };
}
